import { render, staticRenderFns } from "./LineChart.vue?vue&type=template&id=58b37c2c&"
import script from "./LineChart.vue?vue&type=script&lang=js&"
export * from "./LineChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/samenaankoop/src/vue-apps/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58b37c2c')) {
      api.createRecord('58b37c2c', component.options)
    } else {
      api.reload('58b37c2c', component.options)
    }
    module.hot.accept("./LineChart.vue?vue&type=template&id=58b37c2c&", function () {
      api.rerender('58b37c2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/LineChart.vue"
export default component.exports